import React from "react";
import {
  Button,
  Form,
  Input,
  List,
  Timeline,
  Typography
} from "antd/lib/index";
import { connect } from "react-redux";
import { Formik } from "formik";
import { bindActionCreators } from "redux";
import { submitGroupCasillas } from "../../../../redux/actions/actividades";
import { selectCurrentUser } from "../../../../redux/selectors/auth";
import { selectGroupByKey } from "../../../../redux/selectors/groups";

class CasillasDisplay extends React.Component {
  render() {
    const { submitGroupCasillas, currentUser, group, pregunta } = this.props;
    return (
      <React.Fragment>
        <Formik
          initialValues={{
            respuestas: [
              { respuesta: "", numeroPregunta: 1 },
              { respuesta: "", numeroPregunta: 2 },
              { respuesta: "", numeroPregunta: 3 },
              { respuesta: "", numeroPregunta: 4 },
              { respuesta: "", numeroPregunta: 5 },
              { respuesta: "", numeroPregunta: 6 },
              { respuesta: "", numeroPregunta: 7 },
              { respuesta: "", numeroPregunta: 8 },
              { respuesta: "", numeroPregunta: 9 }
            ]
          }}
          onSubmit={(values, { setSubmitting, setStatus }) => {
            const parsedCarr =
              values &&
              values.respuestas &&
              values.respuestas
                .map((val, i) => {
                  return {
                    respuesta: val.respuesta,
                    numeroPregunta: i + 1
                  };
                })
                .filter(x => x.respuesta.length > 0);

            submitGroupCasillas(
              parsedCarr,
              currentUser,
              group,
              setStatus,
              pregunta
            );
          }}
        >
          {props => {
            return (
              <React.Fragment>
                <List
                  itemLayout="vertical"
                  size="large"
                  dataSource={pregunta.preguntas}
                  renderItem={(item, i) => (
                    <Timeline.Item key={i * 40}>
                      <List.Item.Meta
                        avatar={<Typography.Title>{i + 1}</Typography.Title>}
                        title={item.titulo}
                        description={item.descripcion
                          .split("\n")
                          .map(function(item, s) {
                            return (
                              <span key={s}>
                                {item}
                                <br />
                              </span>
                            );
                          })}
                      />

                      <Form.Item label="Respuesta">
                        <Input.TextArea
                          rows={5}
                          autosize={{ minRows: 2 }}
                          type="text"
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                          value={props.values.respuestas[i].respuesta}
                          name={`respuestas[${i}].respuesta`}
                        />
                      </Form.Item>
                    </Timeline.Item>
                  )}
                />

                <Button onClick={props.handleSubmit}>
                  Enviarnos tu avance en la casilla de preguntas
                </Button>
              </React.Fragment>
            );
          }}
        </Formik>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ submitGroupCasillas }, dispatch);

const mapStateToProps = state => {
  const currentUser = selectCurrentUser(state);
  const group = selectGroupByKey(state, currentUser.groupKey);
  return {
    currentUser,
    group
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CasillasDisplay);
